import { createRouter, createWebHistory } from 'vue-router'
import TemplatesMessagesRoutes from './to/Messages/Templates'
import Reports from './to/Reports/Index'
import Controller from './to/Controller/Index'
import Automations from './to/Automations'
import Clients from './to/Clients'
import Ia from './to/Ia'
import ChatRoutes from './to/Chat/Chat'
import ChatInternal from './to/Chat/Internal'
import Settings from './to/Settings'
import Web from './to/Web'
import Channels from './to/Channels'
import Tickets from './to/Tickets'
import Signatures from './to/Settings/Signatures'
import Dashboard from './to/Dashboard'
import CRM from './to/CRM'

const NotFound = () => import('@/views/utils/NotFound.vue')
const Redirect = () => import('@/views/utils/Redirect.vue')
const RateLimit = () => import('@/views/utils/RateLimit.vue')
const AccessQueue = () => import('@/views/utils/AccessQueue.vue')
const SendMessage = () => import('@/views/landing/SendMessage.vue')
const AccessExpired = () => import('@/views/utils/AccessExpired.vue')
const AccessBlocked = () => import('@/views/utils/AccessBlocked.vue')
const ContactEvents = () => import('@/views/landing/ContactEvents.vue')

const routes = [
  ...Dashboard,
  ...TemplatesMessagesRoutes,
  ...Reports, // ok
  ...Automations, // ok
  ...Clients,
  ...Ia,
  ...ChatRoutes,
  ...Settings,
  ...Controller,
  ...Web,
  ...Channels,
  ...Tickets,
  ...Signatures,
  ...ChatInternal,
  { path: '/eventos/contato', component: ContactEvents, name: 'landing.contactEvents', meta: { title: 'Fale Conosco' } },
  { path: '/enviar-mensagem', component: SendMessage, name: 'landing.SendMessage', meta: { title: 'Enviar mensagem' } },
  { path: '/back', component: Redirect, name: 'back', meta: { redirect: window.location.origin } },
  { path: '/redirect/:to(.*)', component: Redirect, name: 'redirect', meta: { title: 'Redirecionando...' } },
  { path: '/fila-de-acesso', component: AccessQueue, name: 'access', meta: { title: 'Por favor, aguarde...' } },
  { path: '/limite-excedido', component: RateLimit, name: 'rate-limit', meta: { title: 'Por favor, aguarde...' } },
  { path: '/acesso-expirado', component: AccessExpired, name: 'expired-access', meta: { title: 'Acesso, expirado' } },
  { path: '/acesso-bloqueado', component: AccessBlocked, name: 'expired-blocked', meta: { title: 'Acesso, bloqueado' } },
  { path: '/:catchAll(.*)', component: NotFound, name: 'NotFound', meta: { title: 'Página não encontrada!' } },

  // Redirects
  {
    path: '/usuarios/:id/seguranca',
    component: Redirect,
    name: 'redirect.security',
    beforeEnter: (to, from, next) => {
      window.location.href = `/v3/usuarios/${to.params.id}/seguranca`
    }
  },
  {
    path: '/perfil/seguranca',
    component: Redirect,
    name: 'my.profile-security',
    beforeEnter: (to, from, next) => {
      window.location.href = `/v3/meu-perfil/seguranca`
    }
  },
  // {
  //   path: '/perfil/voip',
  //   component: Redirect,
  //   name: 'my.profile-sip',
  //   beforeEnter: (to, from, next) => {
  //       window.location.href = `/v3/meu-perfil/sip`
  //   }
  // },
  {
    path: '/usuarios/:id/sip',
    component: Redirect,
    name: 'redirect.sip',
    beforeEnter: (to, from, next) => {
      window.location.href = `/v3/usuarios/${to.params.id}/sip`
    }
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_ROUTER_PATH),
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Página sem nome'
  next()
})

// Verificar se o ambiente é de produção
if (import.meta.env?.VITE_ENV === 'production') {
  // Atualizar as URLs das rotas com '/v2/' se não possuírem
  router.beforeEach((to, from, next) => {
    if (!to.path.startsWith('/v2')) {
      next('/v2' + to.fullPath)
    } else {
      next()
    }
  })
}

export default router
